/**
 * @module FE-CU8_ホームセキュリティ画面
 */
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import TabHeader from '../../components/tabHeader/TabHeader.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import timeParser from '../../utile/timeParser';
import NotificationHistoryTimeline from '../../components/NotificationHistoryTimeline/NotificationHistoryTimeline.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU08';

export default {
  name: 'HomeSecurity',
  components: {
    Header,
    BreadCrumbList,
    TabHeader,
    MobileFooter,
    PcPageTitle,
    PCFooter,
    NotificationHistoryTimeline,
  },
  data(vm) {
    return {
      isActive: true,
      title: vm.$vuetify.lang.t('$vuetify.FECU08ホームセキュリティ画面.ホームセキュリティ'),
      authority: {
        main: '$vuetify.FECU08ホームセキュリティ画面.権限.メインユーザー',
        sub: '$vuetify.FECU08ホームセキュリティ画面.権限.サブユーザー',
      },
      lastUpdateDate: timeParser('2021/12/23 12:15:36'),
      userSecurityOperationAuthority01Image: require('../../assets/images/icon/userSecurityOperationAuthority01.png'),
      rushOrderAuthority01Image: require('../../assets/images/icon/rushOrderAuthority01.png'),
      notificationHistory01Image: require('../../assets/images/icon/notificationHistory01.png'),
      contactAuthority01Image: require('../../assets/images/icon/contactAuthority01.png'),
      deviceContorolAuthority01Image: require('../../assets/images/icon/deviceContorolAuthority01.png'),
      option01Image: require('../../assets/images/icon/option01.png'),
      userSecurityOperationAuthority02Image: require('../../assets/images/icon/userSecurityOperationAuthority02.png'),
      rushOrderAuthority02Image: require('../../assets/images/icon/rushOrderAuthority02.png'),
      notificationHistory02Image: require('../../assets/images/icon/notificationHistory02.png'),
      contactAuthority02Image: require('../../assets/images/icon/contactAuthority02.png'),
      deviceContorolAuthority02Image: require('../../assets/images/icon/deviceContorolAuthority02.png'),
      option02Image: require('../../assets/images/icon/option02.png'),
      // 対象地区メニュー一覧を格納
      displayDistrictInfoList: [],
      lastUpdate: '',
      // 通知履歴一覧を格納
      notificationList: [],
      displayAreaList: [],
      tabNumber: 0,
      tabs: [
        {
          id: 1,
          title: vm.$vuetify.lang.t('$vuetify.FECU08ホームセキュリティ画面.対象地区一覧ボタン'),
        },
        {
          id: 2,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU08ホームセキュリティ画面.通知履歴24時間以内ボタン'
          ),
        },
      ],
      disabledFlag: true,
      isHistoryVisible: true,
      disabledFlagArray: [],
      CONSTANTS: CONSTANTS,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU08ホームセキュリティ画面.ホームセキュリティ'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU08ホームセキュリティ画面.C0001'),
        lastUpdate: vm.$vuetify.lang.t('$vuetify.FECU08ホームセキュリティ画面.最終更新日時'),
        top: vm.$vuetify.lang.t('$vuetify.FECU07.トップ'),
        tabs: [
          {
            id: 1,
            title: vm.$vuetify.lang.t('$vuetify.FECU08ホームセキュリティ画面.対象地区一覧ボタン'),
          },
          {
            id: 2,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU08ホームセキュリティ画面.通知履歴24時間以内ボタン'
            ),
          },
        ],
      };
    },
  },
  /** @type {Methods} */
  methods: {
    active: function () {
      this.isActive = !this.isActive;
    },
    tabSelect: function (num) {
      this.tabNumber = num;
    },
    /**
     * 初期化処理
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     */
    init: async function (queries, method) {
      // let param = "post"; // 検証用
      let param = '/api/common/getRoleList'; // 本番用
      await this.APP_CU9916(param, queries, method);
      param = '/api/homeSecurity/getDisplayDistrictList'; // 本番用
      let ret08 = await this.APP_CU0801(param, queries, method);

      this.$store.commit('setDisplayDistrictTotal', {
        displayDistrictTotal: ret08.contentsInfo.displayDistrictInfoList.length,
      });
      // 対象地区一覧の件数が１件の場合
      if (ret08.contentsInfo.displayDistrictInfoList.length === 1) {
        // 対象地区一覧の件数が1件の場合、VueのStoreに値を保存し対象地区詳細画面に遷移
        this.setDistrictInfo(
          ret08.contentsInfo.displayDistrictInfoList[0].customerNumber,
          ret08.contentsInfo.displayDistrictInfoList[0].districtSplitNumber,
          1
        );
        this.$router.push('displayDistrictDetail');
      } else {
        let promiseList = [];
        this.isHistoryVisible = false;
        let index = 0;
        let allNotificationList = ret08.contentsInfo.notificationInfo.notificationList;
        // 対象地区一覧の件数が2件の場合、APP_CU0901とAPP_CU1901を実行
        for (const element of ret08.contentsInfo.displayDistrictInfoList) {
          const nickname = element.displayDistrictNickname;
          const userType = element.displayDistrictUserType;
          const usagePlan = element.usagePlanId;
          const planTitles = {
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
              '$vuetify.コード.利用プランID.オンライン監視プラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
              '$vuetify.コード.利用プランID.依頼かけつけプラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
              '$vuetify.コード.利用プランID.依頼かけつけプラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
              '$vuetify.コード.利用プランID.セルフ監視プラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
              '$vuetify.コード.利用プランID.セルフ監視プラン',
          };
          const customerNumber = element.customerNumber;
          const districtSplitNumber = element.districtSplitNumber;

          let userSecurityOperationAuthority = userType == 1 ? true : false;
          let rushOrderAuthority = userType == 1 ? true : false;
          let notificationHistory = userType == 1 ? true : false;
          let contactAuthority = userType == 1 ? true : false;
          let deviceContorolAuthority = userType == 1 ? true : false;
          // lint 変数未使用の為コメントアウト
          // let displayDistrictSettingAuthority = userType == 1 ? true : false;

          // 9916権限を参照
          let disabled = false;
          let check1901 = false;
          let lockUpCheck = false;
          this.disabledFlagArray.map((auth) => {
            if (
              auth.displayDistrictUserType == element.displayDistrictUserType &&
              auth.customerNumber == element.customerNumber &&
              auth.districtSplitNumber == element.districtSplitNumber
            ) {
              disabled = auth.disabledFlag;
              if (!disabled) {
                check1901 = auth.check1901;
                lockUpCheck = auth.lockUpCheck;
              }
            }
          });

          this.displayDistrictInfoList = [
            ...this.displayDistrictInfoList,
            {
              displayDistrictNickname: nickname,
              displayDistrictUserType: userType === 1 ? this.authority.main : this.authority.sub,
              usagePlan: planTitles[usagePlan],
              usagePlanId: usagePlan,
              userSecurityOperationAuthority: userSecurityOperationAuthority,
              rushOrderAuthority: rushOrderAuthority,
              notificationHistory: notificationHistory,
              contactAuthority: contactAuthority,
              deviceContorolAuthority: deviceContorolAuthority,
              //displayDistrictSettingAuthority: displayDistrictSettingAuthority,
              displayDistrictSettingAuthority: true, // #29840[機能修正管理表No.62] 各種設定ボタンが増えたので常に表示
              customerNumber: customerNumber,
              districtSplitNumber: districtSplitNumber,
              //isDisabled: disabled,
              isDisabled: false, // #29840[機能修正管理表No.62] 各種設定ボタンが増えたので常に表示
            },
          ];

          if (userType !== 1) {
            // サブユーザーの場合
            const appCu0901Queries = {
              token: sessionStorage.getItem('token'),
              terminalInfo: localStorage.getItem('terminalInfo')
                ? localStorage.getItem('terminalInfo')
                : '',
              customerNumber: element.customerNumber,
              districtSplitNumber: element.districtSplitNumber,
              isSendCommand: false,
            };
            let param = '/api/displayDistrictDetail/init';
            promiseList.push(await this.APP_CU0901(param, appCu0901Queries, method, index));
            if (check1901) {
              param = '/api/displayDistrictSettings/init';
              const appCu1901Queries = {
                token: sessionStorage.getItem('token'),
                terminalInfo: localStorage.getItem('terminalInfo')
                  ? localStorage.getItem('terminalInfo')
                  : '',
                customerNumber: element.customerNumber,
                districtSplitNumber: element.districtSplitNumber,
              };
              promiseList.push(await this.APP_CU1901(param, appCu1901Queries, method, index));
            }
          } else {
            this.isHistoryVisible = true;
          }

          // 通知履歴をマッピング
          this.lastUpdate = ret08.contentsInfo.notificationInfo.lastUpdate.replace(/-/g, '/');

          // 詳細は【 コチラ 】の表示制御を設定
          if (lockUpCheck) {
            allNotificationList.map((notification) => {
              if (
                notification.customerNumber == element.customerNumber &&
                notification.districtSplitNumber == element.districtSplitNumber
              ) {
                notification.warningCheck = true;
              }
            });
          }
          index++;
        }
        await Promise.all(promiseList);

        let onlyOnce = false;
        allNotificationList.forEach((list) => {
          // 前回ログイン以降の通知 を表示
          if (!onlyOnce && list.isNewMessageLabel) {
            list.newMessageFromHere = true;
            onlyOnce = true;
          }
        });

        this.notificationList = allNotificationList;
      }
    },
    /**
     * ユーザー権限一覧取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU9916: async function (param, queries, method) {
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: [
            //       {
            //         customerNumber: "1111111",
            //         districtSplitNumber: "1111111",
            //         displayDistrictUserType: 1,
            //         userAuthority: {
            //           securityOperation: true,
            //           rushOrder: true,
            //           notificationHistory: true,
            //           deviceContorol: true,
            //           contact: true,
            //           nicknameSetting: true,
            //           IDCardKeyInfoSetting: true,
            //           watchOverInfoDeliverySetting: true,
            //           lockUpCheck: true,
            //           targetAtHomeSetting: true,
            //           userManagement: true,
            //           emergencyContact: true,
            //         },
            //       },
            //       {
            //         customerNumber: "2222222",
            //         districtSplitNumber: "2222222",
            //         displayDistrictUserType: 2,
            //         userAuthority: {
            //           securityOperation: true,
            //           rushOrder: false,
            //           notificationHistory: true,
            //           deviceContorol: false,
            //           contact: true,
            //           nicknameSetting: false,
            //           IDCardKeyInfoSetting: true,
            //           watchOverInfoDeliverySetting: false,
            //           lockUpCheck: true,
            //           targetAtHomeSetting: false,
            //           userManagement: true,
            //           emergencyContact: false,
            //         },
            //       },
            //       {
            //         customerNumber: "3333333",
            //         districtSplitNumber: "3333333",
            //         displayDistrictUserType: 2,
            //         userAuthority: {
            //           securityOperation: false,
            //           rushOrder: false,
            //           notificationHistory: false,
            //           deviceContorol: false,
            //           contact: false,
            //           nicknameSetting: false,
            //           IDCardKeyInfoSetting: false,
            //           watchOverInfoDeliverySetting: false,
            //           lockUpCheck: false,
            //           targetAtHomeSetting: false,
            //           userManagement: false,
            //           emergencyContact: false,
            //         },
            //       },
            //     ],
            //     cameraInfoList: [
            //       {
            //         customerNumber: "customerNumber",
            //         districtSplitNumber: "1",
            //         deviceID: "1111",
            //         cameraUserType: 1,
            //         userAuthority: {
            //           anticrimeCameraVideos: true,
            //           rushOrder: true,
            //           notificationHistory: true,
            //           contact: true,
            //           nicknameSetting: false,
            //           userManagement: false,
            //           emergencyContact: false,
            //         },
            //       },
            //     ],
            //   },
            // };

            for (let i = 0; i < apiData.contentsInfo.displayDistrictInfoList.length; i++) {
              let userAuthority = apiData.contentsInfo.displayDistrictInfoList[i].userAuthority;
              let check1901 =
                userAuthority.securityOperation ||
                userAuthority.nicknameSetting ||
                userAuthority.IDCardKeyInfoSetting ||
                userAuthority.watchOverInfoDeliverySetting ||
                userAuthority.notificationHistory;
              let auth = {
                displayDistrictUserType: '',
                customerNumber: '',
                districtSplitNumber: '',
                disabledFlag: false,
                check1901: check1901,
                lockUpCheck: userAuthority.lockUpCheck,
              };
              if (
                userAuthority.securityOperation === true ||
                userAuthority.rushOrder === true ||
                userAuthority.notificationHistory === true ||
                userAuthority.deviceContorol === true ||
                userAuthority.contact === true ||
                userAuthority.nicknameSetting === true ||
                userAuthority.IDCardKeyInfoSetting === true ||
                userAuthority.watchOverInfoDeliverySetting === true ||
                userAuthority.lockUpCheck === true ||
                userAuthority.targetAtHomeSetting === true ||
                userAuthority.userManagement === true ||
                userAuthority.emergencyContact === true
              ) {
                // その地区のユーザー権限で一つでもtrueがある場合、対象地区詳細画面に遷移できるようにする
                auth.disabledFlag = false;
              } else {
                auth.disabledFlag = true;
              }
              auth.customerNumber = apiData.contentsInfo.displayDistrictInfoList[i].customerNumber;
              auth.districtSplitNumber =
                apiData.contentsInfo.displayDistrictInfoList[i].districtSplitNumber;
              auth.displayDistrictUserType =
                apiData.contentsInfo.displayDistrictInfoList[i].displayDistrictUserType;
              this.disabledFlagArray[i] = auth;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
      return apiData;
    },
    /**
     * 対象地区一覧情報取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU0801: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: [
            //       {
            //         displayDistrictNickname:
            //           "自宅",
            //         customerNumber: "1111111",
            //         districtSplitNumber: "1111111",
            //         displayDistrictUserType: 1,
            //         usagePlanId: 1,
            //       },
            //       {
            //         displayDistrictNickname: "叔母の家",
            //         customerNumber: "2222222",
            //         districtSplitNumber: "2222222",
            //         displayDistrictUserType: 2,
            //         usagePlanId: 2,
            //       },
            //     ],
            //     notificationInfo: {
            //       lastUpdate: "2022-05-30 12:00:00",
            //       notificationList: [
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-01 01:00:00",
            //           contentType: 1,
            //           serviceType: "N01",
            //           customerNumber: "11111-11111",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-01 06:00:00",
            //           contentType: 1,
            //           serviceType: "A10",
            //           customerNumber: "22222-22222",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "玄関センサー",
            //           securityDestinationName: "自宅",
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "綜警 太郎",
            //           postedDatetime: "2022-05-20 12:00:00",
            //           contentType: 0,
            //           serviceType: "S05",
            //           customerNumber: "33333-33333",
            //           operatorInfo: "綜警 太郎",
            //           sensorName: "玄関戸締り",
            //           securityDestinationName: "自宅",
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J07",
            //           customerNumber: "44444-44444",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           isPersonNotification: true,
            //         },
            //       ],
            //     },
            //   },
            // };
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * 対象地区詳細画面 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @param {*} index インデックス
     * @returns apiData レスポンス
     */
    APP_CU0901: async function (param, queries, method, index) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: {
            //       usagePlanId: 1,
            //       customerNumber: "1111111",
            //       securityDestinationName: "自宅",
            //       districtSplitNumber: "1111111",
            //       districtSplitName: "リビング",
            //       displayDistrictNickname: "リビング",
            //     },
            //     displayDistrictSecurityStatus: {
            //       notificationCount: 3,
            //       serviceTypeList: [
            //         { serviceType: "A01" },
            //         { serviceType: "A02" },
            //         { serviceType: "A03" },
            //       ],
            //     },
            //     displayDistrictAuthority: {
            //       displayDistrictUserType: "1",
            //       userSecurityOperationAuthority: false,
            //       rushOrderAuthority: false,
            //       notificationHistory: false,
            //       contactAuthority: false,
            //       deviceContorolAuthority: false,
            //     },
            //     notificationInfo: {
            //       lastUpdate: "2022-05-30 12:00:00",
            //       notificationList: [
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-01 01:00:00",
            //           contentType: 1,
            //           serviceType: "N01",
            //           customerNumber: "11111-11111",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           isPersonNotification: false,
            //         },
            //       ],
            //     },
            //     unitCommandInfo: [
            //       {
            //         sendCustomerNumber: "1111111",
            //         sendCommandKey: "1",
            //       },
            //     ],
            //   },
            // };

            if (apiData.contentsInfo) {
              this.displayDistrictInfoList[index].userSecurityOperationAuthority =
                apiData.contentsInfo.displayDistrictAuthority.userSecurityOperationAuthority;
              this.displayDistrictInfoList[index].rushOrderAuthority =
                apiData.contentsInfo.displayDistrictAuthority.rushOrderAuthority;
              this.displayDistrictInfoList[index].notificationHistory =
                apiData.contentsInfo.displayDistrictAuthority.notificationHistory;
              this.displayDistrictInfoList[index].contactAuthority =
                apiData.contentsInfo.displayDistrictAuthority.contactAuthority;
              this.displayDistrictInfoList[index].deviceContorolAuthority =
                apiData.contentsInfo.displayDistrictAuthority.deviceContorolAuthority;
            }

            if (apiData.contentsInfo.displayDistrictAuthority.notificationHistory) {
              this.isHistoryVisible = true;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * 表示地区設定画面 対象地区設定データ取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @param {*} index インデックス
     */
    APP_CU1901: async function (param, queries, method, index) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            // contentsInfo: {
            //   displayDistrictInfo: {
            //     displayDistrictFacilityName: "aaa",
            //     usagePlanId: 1,
            //     customerNumber: "111",
            //     districtSplitName: "aaa",
            //     districtSplitNumber: "111",
            //   },
            //   displayDistrictAuthority: {
            //     nicknameSetting: false,
            //     IDCardKeyInfoSetting: false,
            //     notificationDeliverySetting: true,
            //     watchOverInfoDeliverySetting: false,
            //     securityOperation: false,
            //   },
            // },
            // };

            if (
              apiData.contentsInfo.displayDistrictAuthority.nicknameSetting == true ||
              apiData.contentsInfo.displayDistrictAuthority.IDCardKeyInfoSetting == true ||
              apiData.contentsInfo.displayDistrictAuthority.notificationDeliverySetting == true ||
              apiData.contentsInfo.displayDistrictAuthority.watchOverInfoDeliverySetting == true
            ) {
              this.displayDistrictInfoList[index].displayDistrictSettingAuthority = true;
            }
          },
          (error) => {
            if (error.message.includes('403')) {
              // 表示地区権限が全てfalseとして扱う
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * お客様番号と対象地区番号をストアに保存
     * @param {*} customerNumber お客様番号
     * @param {*} districtSplitNumber 対象地区番号
     * @param {*} type
     */
    setDistrictInfo: function (customerNumber, districtSplitNumber, type) {
      this.$store.commit('setCustomerNumber', {
        customerNumber: customerNumber,
      });
      this.$store.commit('setDistrictSplitNumber', {
        districtSplitNumber: districtSplitNumber,
      });
      if (type == 2) {
        this.$router.push('displayDistrictDetail');
      }
    },
  },
  watch: {
    tabNumber(num) {
      this.$store.commit('setHistoryTabNumber', { historyTabNumber: num });
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.tabNumber = this.$store.state.historyTabNumber;
    this.$store.state.currentDisplayType = 1;

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    // 正常系を確認したい場合は下記のコメントを解除する
    let method = 'post';
    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
    };

    await this.init(queries, method);
    //初期通信完了後に画面を表示
    this.isShowPage = true;
  },
};
